import { SkeletonBox } from "./SkeletonBox";

export const SkeletonCard = ({ mode }) => (
  <div
    // className={styles.mgx_card}
    style={{
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      cursor: "default",
      backgroundColor: mode ? "#1B1D21" : "#fff",
    }}
  >
    {/* Top: avatar + text, mirrors ProdLineInfoCard's .top */}
    <div style={{ display: "flex", gap: "10px", padding: "12px", flex: 1 }}>
      <SkeletonBox
        width="44px"
        height="44px"
        mode={mode}
        style={{ borderRadius: "50%", flexShrink: 0 }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <SkeletonBox width="70%" height="14px" mode={mode} style={{ marginBottom: "8px" }} />
        <SkeletonBox width="45%" height="18px" mode={mode} style={{ borderRadius: "10px", marginBottom: "8px" }} />
        <SkeletonBox width="55%" height="12px" mode={mode} />
      </div>
    </div>

    {/* Footer: capacity + hours chips, mirrors .footer, pinned to bottom via flex column */}
    <div style={{ display: "flex", gap: "8px", padding: "0 12px 12px" }}>
      <SkeletonBox width="80px" height="22px" mode={mode} style={{ borderRadius: "11px" }} />
      <SkeletonBox width="70px" height="22px" mode={mode} style={{ borderRadius: "11px" }} />
    </div>
  </div>
);